"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getTimeAgo } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
};
export default function HorizontalSmallCategoryNews(t0) {
  const $ = _c(39);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    timeAgo: t3,
    slug
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "WEATHER",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const category = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BB0\u0BCD\u0BA8\u0BBE\u0B9F\u0B95 \u0BAE\u0B95\u0BCD\u0B95\u0BB3\u0BBF\u0BA9\u0BCD \u0BA8\u0BB2\u0BA9\u0BC7 \u0B8E\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BA9\u0BC1\u0BB0\u0BBF\u0BAE\u0BC8: \u0B9F\u0BBF.\u0B95\u0BC7.\u0B9A\u0BBF\u0BB5\u0B95\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD \u0B9F\u0BCD\u0BB5\u0BC0\u0B9F\u0BCD!",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const title = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: "May 17, 2023",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const timeAgo = t6;
  const router = useRouter();
  const categoryValue = category?.value || "";
  const titleValue = title?.value || "";
  const t7 = timeAgo?.value;
  let t8;
  if ($[6] !== t7) {
    t8 = getTimeAgo(t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const timeAgoValue = t8;
  let t9;
  if ($[8] !== router || $[9] !== sectionUrl) {
    t9 = e => {
      if (sectionUrl) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrl);
      }
    };
    $[8] = router;
    $[9] = sectionUrl;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const handleCategoryClick = t9;
  let t10;
  if ($[11] !== category?.customClass || $[12] !== category?.hidden || $[13] !== categoryValue || $[14] !== handleCategoryClick || $[15] !== sectionUrl) {
    t10 = !category?.hidden && <>{sectionUrl ? <span className={`text-11-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <div className={`text-11-tamil-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>}</>;
    $[11] = category?.customClass;
    $[12] = category?.hidden;
    $[13] = categoryValue;
    $[14] = handleCategoryClick;
    $[15] = sectionUrl;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== title?.customClass || $[18] !== title?.hidden || $[19] !== titleValue) {
    t11 = !title?.hidden && <h3 className={`text-14-tamil-700 text-1B1B1B font-medium leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[17] = title?.customClass;
    $[18] = title?.hidden;
    $[19] = titleValue;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== timeAgo?.customClass || $[22] !== timeAgo?.hidden || $[23] !== timeAgoValue) {
    t12 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-4D4D4D ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[21] = timeAgo?.customClass;
    $[22] = timeAgo?.hidden;
    $[23] = timeAgoValue;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = slug ? `/${slug}` : undefined;
  let t14;
  if ($[25] !== slug || $[26] !== t13 || $[27] !== titleValue) {
    t14 = <MessageIcon id="news-cat-vert-message-icon" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} articleUrl={t13} />;
    $[25] = slug;
    $[26] = t13;
    $[27] = titleValue;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="flex items-center justify-between">{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t15) {
    t16 = <article className="p-4"><div className="flex flex-col gap-3">{t10}{t11}{t15}</div></article>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const content = t16;
  if (slug) {
    const t17 = `/${slug}`;
    let t18;
    if ($[36] !== content || $[37] !== t17) {
      t18 = <Link href={t17} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[36] = content;
      $[37] = t17;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    return t18;
  }
  return content;
}